import useWindowsSize from "@/Hooks/useWindowsSize";
import Skeleton from "react-loading-skeleton";

type Props = {
  totales: number;
};

export const DefaultCategories = ({ totales }: Props): JSX.Element => {
  const rows = [];

  for (let i = 0; i < totales; i++) {
    rows.push(<DefaultCategory key={i} />);
  }

  return <>{rows}</>;
};

export const DefaultCategory = (): JSX.Element => {
  const { width } = useWindowsSize();
  const movil = () => (
    <div
      className={`col-xl-2 col-lg-6 col-md-6 col-sm-6 col-12 ${
        width <= 1080 ? "d-flex justify-content-center" : ""
      }`}>
      <div
        className={`d-flex flex-column ${
          width > 700 && width < 1202
            ? "develop__pdre__card"
            : width <= 700
            ? "w-100"
            : ""
        }`}>
        <div className="p-1 shadow mb-1 bg-white develop__borderRadius">
          <div className="card w-100 text-center border-0 develop__borderRadius develop__card develop__card__skeleton">
            <h4 className="mx-auto my-auto text-white">Cargando ...</h4>
          </div>
        </div>
        <div className="p-1 w-100 text-center">
          <h4 className="develop___ColorText mt-2">
            <Skeleton height={24} />
          </h4>
        </div>
      </div>
    </div>
  );

  const desktop = () => (
    <div className={`${width >= 1500 ? "col-3" : "col-4"} mt-2`}>
      <div className="develop__pdre__card__alto">
        <div className="shadow mb-1 bg-white develop__borderRadius">
          <div className="card w-100 text-center border-0 develop__borderRadius img__develop develop__card__skeleton__v2">
            <h4 className="mx-auto my-auto text-white">Cargando ...</h4>
          </div>
        </div>
        <div className="p-1 w-100 text-center">
          <h4 className="develop___ColorText mt-3">
            <Skeleton height={24} />
          </h4>
        </div>
      </div>
    </div>
  );

  return width <= 1202 ? movil() : desktop();
};
